import { urls, baseUrl } from "../../config/urlConfig";
import { HTTP } from "../core/http.service";

export class PaymentService {

    static getPaymentDetailsById = async (paymentId) => {
        console.log(paymentId, "paymentId");
        const result = await HTTP.get(`${urls.getPaymentDetails}${paymentId}`);
        // console.log('result ', result)
        if (result && result.data) {
            return result.data;
        }
        return undefined;
    };

    static getPaymentStatus = async (beneId, payEngineId) => {
        const result = await HTTP.get(`${urls.getPaymentStatus}${beneId}/${payEngineId}`);
        if (result && result.data) {
            return result.data;
        }
        return undefined;
    };

    static doPaymentByCard = async (req, paymentId) => {
        const result = await HTTP.get(`${urls.payByCard}${paymentId}`, {headers: { },
        maxRedirects: 0}, {responseType: 'document'});
        if (result && result.data) {
            return result.data;
        }
        return undefined;
    }

    static sendEmail = async (paymentId) => {
        console.log('payment id ', paymentId);
        const result = await HTTP.get(`${urls.sendPaymentNotification}${paymentId}`);
        if (result && result.data) {
            return result.data;
        }
        return undefined;
    }

    static getTokenById = async (Id) => {
        console.log(Id, "Id");
        const result = await HTTP.get(`${urls.getToken}/${Id}`);
        console.log('result ', result)
        if (result && result.data) {
            return result.data;
        }
        return undefined;
    };

    static getPaymentsByTransactionId = async (paymentId) => {
        const result = await HTTP.get(`${urls.getPayments}${paymentId}`);
        
        if (result && result.data) {
            return result.data;
        }
        
        return undefined;
    };
    
    static fetchCurrencyDecimals = async () => {
        const url = `${urls.currencyDecimals}`
        const result = await HTTP.get(url)

        if (result.status == 200) {
            return result;
        }

        return undefined
    }

}